import { Injectable } from '@angular/core';
import { filter, Observable, tap } from 'rxjs';

import { ImConferenceMemberStatusEnum, ImConferenceModeEnum, ImGroupMemberTypeEnum } from '@app/api/im/dtos';

import { AuthService } from '../auth/services/auth.service';
import { WsClient } from './ws-client';

export enum WsConferenceMessageTypeEnum {
  Conference = 'conference',
  Member = 'member',
  Group = 'group',
  GroupMember = 'group-member',
}

export enum WsConferenceMessageOperationEnum {
  Add = 'add',
  Del = 'del',
  Mod = 'mod',
  StartSpeak = 'start-speak',
  EndSpeak = 'end-speak',
}

export interface WsConferenceMessage {
  type: WsConferenceMessageTypeEnum;
  operation: WsConferenceMessageOperationEnum;
  groupid: string;
  confInfo?: {
    mode?: ImConferenceModeEnum;
  };
  member?: {
    id: number;
    memberID: string;
    memberType: ImGroupMemberTypeEnum;
    defaultConf?: boolean;
    status: ImConferenceMemberStatusEnum;
    deviceId?: string;
    memberName: string;
    name?: string;
    current?: boolean;
  };
}

@Injectable({
  providedIn: 'root',
})
export class WsConferenceService {
  private readonly ws = new WsClient<WsConferenceMessage>();

  public get message$(): Observable<WsConferenceMessage> {
    return this.ws.message$.pipe(filter(Boolean));
  }

  constructor(private readonly authService: AuthService) {
    this.authService.token$.pipe(tap((token) => this.handleTokenChanged(token))).subscribe();
  }

  protected handleTokenChanged(token: string | null): void {
    if (token) {
      this.ws.connect('/bvcsp/v1/ws/event/conference', token);
    } else {
      this.ws.disconnect();
    }
  }
}
